import React, { Component } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { propTypes } from '../../util/types';
import { obfuscatedCoordinates } from '../../util/maps';
import { getLocationForDisplay, getLocationPrivacyNotice } from '../../util/locationPrivacy';
import { Heading, Map } from '../../components';

import css from './ListingPage.module.css';

/**
 * The SectionMapMaybe component.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @param {propTypes.latlng} [props.geolocation] - The geolocation
 * @param {propTypes.uuid} props.listingId - The listing id
 * @returns {JSX.Element} section map maybe component
 */
class SectionMapMaybe extends Component {
  constructor(props) {
    super(props);
    this.state = { isStatic: true };
  }

  render() {
    const { 
      className, 
      rootClassName, 
      geolocation, 
      publicData, 
      listingId, 
      mapsConfig,
      listing,
      transaction,
      currentUser,
      process
    } = this.props;

    if (!geolocation) {
      return null;
    }

    // Get appropriate location data based on privacy rules
    const locationData = getLocationForDisplay(listing, transaction, currentUser, process);
    const address = locationData?.address || (publicData && publicData.location ? publicData.location.address : '');
    const displayCoordinates = locationData?.origin || geolocation;
    const isApproximate = locationData?.isApproximate;
    
    const classes = classNames(rootClassName || css.sectionMap, className);
    const cacheKey = listingId ? `${listingId.uuid}_${geolocation.lat}_${geolocation.lng}` : null;

    // Use obfuscated coordinates for approximate locations or when fuzzy is enabled
    const shouldObfuscate = mapsConfig.fuzzy.enabled || isApproximate;
    const mapProps = shouldObfuscate
      ? { obfuscatedCenter: obfuscatedCoordinates(displayCoordinates, mapsConfig.fuzzy.offset, cacheKey) }
      : { address, center: displayCoordinates };
    const map = <Map {...mapProps} useStaticMap={this.state.isStatic} />;

    return (
      <section className={classes} id="listing-location">
        <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
          <FormattedMessage id="ListingPage.locationTitle" />
        </Heading>
        {isApproximate && mapsConfig.locationPrivacy?.showPrivacyNotice && (
          <div className={css.locationPrivacyNotice}>
            <FormattedMessage id={getLocationPrivacyNotice(isApproximate)} />
          </div>
        )}
        {this.state.isStatic ? (
          <button
            className={css.map}
            onClick={() => {
              this.setState({ isStatic: false });
            }}
          >
            {map}
          </button>
        ) : (
          <div className={css.map}>{map}</div>
        )}
      </section>
    );
  }
}

export default SectionMapMaybe;
